<template>
  <layout :titlePage="'Transferir para conta'" :route="{ name: 'carteira' }">
    <submenuBack v-if="hasToShowNewMenu" />
    <div class="container has-text-centered">
      <div
        class="columns columns--full is-vcentered is-centered wallet-withdraw"
      >
        <div class="column" style="max-width: 750px">
          <div class="wallet-withdraw__transfer-pix">
            <p class="wallet-withdraw__title">
              <b>Como você deseja utilizar o seu saldo neste momento?</b>
            </p>

            <div
              id="shopping-box"
              class="option-box"
              @click="userValidateToRedirect('shopping')"
            >
              <img class="option-box-image" :src="shoppingImg" />
              <div class="option-box-content">
                <div class="option-label-text">
                  Utilizar parte do saldo para comprar produtos no Shopping
                  Casar.com
                </div>
                <ul class="option-list">
                  <div
                    v-if="
                      bonusReceived && bonusReceived.expirable_bonus_amount > 0
                    "
                    id="bonus-box"
                    class="bonus-label"
                  >
                    <img :src="giftIcon" />Você ganhou R${{
                      Number.parseInt(bonusReceived.expirable_bonus_amount)
                    }}
                    na próxima compra!
                  </div>
                  <li class="option-list-item">
                    4% de cashback em cada compra
                  </li>
                  <li class="option-list-item">
                    Receba os itens no conforto da sua casa
                  </li>
                </ul>
              </div>
            </div>

            <div class="option-box" @click="goToWithdraw">
              <img class="option-box-image" :src="pixImg" />
              <div class="option-box-content">
                <div class="option-label-text">
                  Transferir o saldo para minha conta bancária via PIX
                </div>
                <ul class="option-list">
                  <li class="option-list-item">
                    Transferência gratuita e ilimitada
                  </li>
                  <li class="option-list-item">Receba em poucas horas</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import shoppingImg from '@/assets/img/shopping.png'
import pixImg from '@/assets/img/withdraw-pix.png'
import giftIcon from '@/assets/img/gift-icon.png'

import clock from '@/assets/img/clock-blue.png'

import layout from '@/layouts/Default.vue'
import submenuBack from '@/layouts/parts/SubmenuBack.vue'

import loadingViewMixin from '@/mixins/loadingViewMixin'
import walletDataMixin from '@/mixins/walletDataMixin'

import verifyDataUserMixin from '@/mixins/verifyDataUserMixin'

export default {
  mixins: [loadingViewMixin, walletDataMixin, verifyDataUserMixin],

  components: {
    layout,
    submenuBack,
  },

  computed: {
    userDataTransfer: {
      get() {
        return this.$store.state.wallet.userDataTransfer
      },
      set(payload) {
        this.$store.dispatch('setSelectedAccountTransfer', payload)
      },
    },

    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    hasToShowNewMenu() {
      return this.wedSiteInfo.site_menu_versao ? true : false
    },
  },

  data() {
    return {
      shoppingImg,
      pixImg,
      giftIcon,
      clock,
    }
  },

  methods: {
    goToWithdraw() {
      this.$ga.event('carteira', 'click', 'carteira-pix-tela-intermediaria')
      this.$router.push({ name: 'carteira-saque' })
    },
    userValidateToRedirect(params) {
      this.$ga.event(
        'carteira',
        'click',
        'carteira-shopping-tela-intermediaria'
      )
      if (this.verifyDataUser()) {
        this.goTo(params)
        document.getElementsByClassName('navbar-item')[0].click()
      } else {
        this.$refs.CPFModalPix.open()
      }
    },
  },
}
</script>

<style lang="scss">
.navbar-item {
  display: flex;
}

#bonus-box {
  animation: shakeBonus 0.5s infinite;
  animation-delay: 1s;
  animation-iteration-count: 3;
}

#bonus-box:hover {
  animation: shakeBonus 0.5s;
  animation-iteration-count: infinite;
}

@keyframes shakeShopping {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(5px);
  }
  50% {
    transform: translateY(-5px);
  }
  75% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes shakeBonus {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(3px);
  }
  50% {
    transform: translateY(-3px);
  }
  75% {
    transform: translateY(3px);
  }
  100% {
    transform: translateY(0);
  }
}

.option-box {
  margin-bottom: 32px !important;
  margin: 8px auto;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid $gray-4;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-transition: 0.2s ease;
  transition: 0.2s ease;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  height: 192px;
  width: 520px;
  align-items: center;
  // display: flex;

  @media screen and (max-width: 420px) {
    width: auto;
    height: auto;
    display: block;
  }
}

.option-box:hover {
  cursor: pointer;
  background-color: #f6f9fb;
}

.option-box-content {
  display: block;
  text-align: left;
  margin-left: 15px;
}

.option-label-text {
  font-size: 16px;
  font-weight: 700;
}

.bonus-label {
  width: 325px;
  height: 40px;
  background: $primary;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  margin-left: -20px;
  margin-bottom: 8px;
}

.option-list {
  list-style: disc;
  margin-left: 20px;
  margin-top: 8px;
}

.option-list-item {
  color: #3dafb0;
  font-weight: 700;
  font-size: 16px;
}

.layout {
  overflow: hidden;
}

.wallet-withdraw {
  display: flex;
  padding: 10px 20px;

  &__msg {
    display: flex;
    justify-content: flex-start;
    text-align: left;
    align-items: center;
    padding: 19px;
    border-radius: 8px;
    border: solid 1px $gray-4;

    p {
      margin-left: 8px;
      font-size: 14px;
    }
  }

  &__transfer-pix {
    padding: 35px 0;
  }

  &__title {
    font-size: 24px;
    font-weight: bold;
    color: $gray-7;
    padding-bottom: 20px;

    @media (max-width: $tablet) {
      padding-bottom: 16px;
    }
  }

  &__subtitle {
    font-size: 16px;
    color: $gray-5;
    padding-bottom: 15px;
    max-width: 80%;
    margin: 0 auto;

    @media (max-width: $tablet) {
      padding-bottom: 16px;
    }
  }

  &__info-title {
    font-family: Lato;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.25;
    color: #5b6674;
    text-align: left;
    padding-bottom: 8px;
  }

  &__info-box {
    margin-bottom: 24px;

    p {
      color: #5b6674;
      font-family: Lato;
      font-size: 16px;

      span {
        color: #048a8b;
        font-weight: bold;
      }
    }

    &--time {
      padding: 16px;
      border-radius: 8px;
      border: solid 1px #aedfe6;
      background-color: #f5fdfe;
      font-family: Lato;
      font-size: 14px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 23px;

      p {
        color: #5b6674;
        padding-left: 8px;
        text-align: left;

        strong {
          color: #5b6674;
        }

        span {
          color: #048a8b;
          font-weight: bold;
        }
      }

      @media (max-width: $tablet) {
        margin-bottom: 16px;
      }
    }

    &--alert {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 16px;

      p {
        margin-left: 10px;
      }
    }

    @media (max-width: $tablet) {
      margin-bottom: 16px;
    }
  }
}

.accounts-registered {
  &--item {
    cursor: pointer;
  }

  .disabled {
    cursor: not-allowed;
    opacity: 0.5;

    .wallet-withdraw {
      &__box {
        background-color: #f7fafb;

        &:hover {
          box-shadow: none;
        }
      }
    }
  }
}

@media (max-width: $tablet) {
  hr {
    margin: 16px 0;
  }
}
</style>
